import {
  ON_GEL_UPDATE,
  ON_GEL_SELECT,
  ON_SUBMIT,
  ON_RESET,
  CLOSE_FEEDBACK,
  ON_DROP_DOWN_SUBMIT,
  ON_DROP_DOWN_RESET,
  CLOSE_DROP_DOWN_FEEDBACK,
  ON_DROP_DOWN_UPDATE,
  ON_DROP_DOWN_SELECT
} from '../Redux.constants';

export const onGelSubmit = (params) => ({
  type: ON_SUBMIT,
  payload: params,
});

export const onGelReset = (params) => ({
  type: ON_RESET,
  payload: params,
});

export const onCloseFeedback = (params) => ({
  type: CLOSE_FEEDBACK,
  payload: params,
});

export const onGelUpdate = (params) => ({
  type: ON_GEL_UPDATE,
  payload: params,
});

export const onGelSelect = (params) => ({
  type: ON_GEL_SELECT,
  payload: params,
});



// New drop down actions
export const onDropDownSubmit = (params) => ({
  type: ON_DROP_DOWN_SUBMIT,
  payload: params,
});

export const onDropDownReset = (params) => ({
  type: ON_DROP_DOWN_RESET,
  payload: params,
});

export const onDropDownCloseFeedback = (params) => ({
  type: CLOSE_DROP_DOWN_FEEDBACK,
  payload: params,
});

export const onDropDownUpdate = (params) => ({
  type: ON_DROP_DOWN_UPDATE,
  payload: params,
});

export const onDropDownSelect = (params) => ({
  type: ON_DROP_DOWN_SELECT,
  payload: params,
});
